<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img class="logo-img" src="@/assets/img/logo_white.png" alt="logo图">
    </div>
    <p class="title">{{ config.companyName }}</p>
    <p class="address_tel_fax">
      <!-- <span>地址：公司地址</span> -->
      <span>Tel：{{ config.telephone }}</span>
    </p>
    <p class="email_wx">
      <span>邮箱：{{config.email}}</span>
      <!-- <span>微信号：{{ config.wechat }}</span> -->
    </p>
    <p class="email_wx">
      <!-- <span>邮箱：{{config.email}}</span> -->
      <span>微信号：{{ config.wechat }}</span>
    </p>
    <p class="copy">Copyright &copy; 2023 - {{ new Date().getFullYear() }} {{ config.companyName }}</p>
  </div>
</template>
<script>
import config from '@/config';

export default {
  name: "Footer",
  data() {
    return {
      config
    };
  }
  
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  /* width: 130px; */
  display: inline-block;
  text-align: center;
  margin: 50px auto 20px;
}

.logo-img {
  height: 50px;
}

.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue